import { render, staticRenderFns } from "./Continut.vue?vue&type=template&id=63cb48e9&scoped=true&"
import script from "./Continut.vue?vue&type=script&lang=js&"
export * from "./Continut.vue?vue&type=script&lang=js&"
import style0 from "./Continut.vue?vue&type=style&index=0&id=63cb48e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb48e9",
  null
  
)

export default component.exports